import {getConfigFields} from '../fields.js'
import {formFieldIds} from '../values.js'

const {postalCode, plate} = formFieldIds

const formVehicleExtraDataFieldsConfig = [
  getConfigFields[plate](),
  getConfigFields[postalCode]({customProps: {help: 'Te mostraremos profesionales cerca de ti'}})
]

export const formVehicleExtraDataFormConfig = {
  fields: formVehicleExtraDataFieldsConfig
}
